import { render, staticRenderFns } from "./BrandList.vue?vue&type=template&id=df929f36&scoped=true&"
import script from "./BrandList.vue?vue&type=script&lang=js&"
export * from "./BrandList.vue?vue&type=script&lang=js&"
import style0 from "./BrandList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BrandList.vue?vue&type=style&index=1&id=df929f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df929f36",
  null
  
)

export default component.exports